export const Messages = {
  "Visor.onSearch.error.title": "¡Atención!",
  "Visor.onSearch.error.msg":
    "La parcela ingresada no se encuentra registrada en el parcelario del SNC.",
  "Visor.searchControl.tooltip": "Despliega el panel de busqueda de parcelas.",
  "Visor.coordControl.tooltip":
    "Haga Click sobre el mapa para recuperar la ubicación.",
  "Visor.helpControl.tooltip": "Inicia el tour por la aplicación.",
  "Visor.infoControl.tooltip":
    "Haga click sobre sobre una parcela para recuperar la información.",
  "Visor.lonlatControl.tooltip":
    "Despliega el panel de busqueda por Longitud y Latitud.",
  "Visor.geoloControl.tooltip":
    "Recupera la ubicación actual del GPS del dispositivo.",
    

  "Visor.getFeatureInfo.info.title": "¡Atención!",
  "Visor.getFeatureInfo.info.msg":
    "Para recuperar la información de una parcela debe incrementar el nivel del zoom",

  "Visor.getFeatureInfo.error.title": "¡Atención!",
  "Visor.getFeatureInfo.error.msg":
    "No se pudo recuperar correctamente la inforamción de la parcela favor incrementa el nivel el nivel de zoom y selecciona correctamente la parcela.",

  "BaseForm.agregar.confirm": "¿Esta seguro de que desea guardar el registro?",
  "BaseForm.agregar.success": "¡Los datos se ha registrado exitosamente!",
  "BaseForm.obtener.error": "Ocurrió un error al recuperar los datos.",

  /*Proyectos */
  "Proyecto.agregar.confirm": "¿Esta seguro de que desea guardar el proyecto?",
  "Proyecto.agregar.success": "El proyecto se ha registrado correctamente.",
  "Proyecto.obtener.error": "Ocurrió un error al recuperar los datos del proyecto.",
  "Proyecto.validation.nombre.require": "Debe especificar el nombre del proyecto.",
  "Proyecto.validation.matricula.require": "Debe especificar el número de matricula del inmueble.",
  "Proyecto.validation.id_distrito.require": "Debe seleccionar un distrito.",
  "Proyecto.validation.id_departamento.require": "Debe seleccionar un departamento.",
  "Proyecto.validation.padron.require": "Debe especificar el número del padrón matriz.",
  "Proyecto.validation.zona.require": "Debe especificar la zona de la cuenta corriente matriz.",
  "Proyecto.validation.manzana.require": "Debe especificar la manzana de la cuenta corriente matriz.",
  "Proyecto.validation.lote.require": "Debe especificar el lote de la cuenta corriente matriz.",

  /**
   * Se encarga de recurpear el mensaje e injectar las variales que se encuentran definidas en
   * el string del mensaje de forma ${propiedad}
   *
   * @param {string} key codigo del mensaje que se encuentra en el map de MESSAGES.
   * @param {object} data json que cotiene los datos a reemplazar en la cadena.
   */
  get(key, data) {
    var tpl = Messages[key];
    if (typeof data === "undefined") {
      return tpl;
    }
    return tpl.replace(/\$\{([^\)]+)?\}/g, function($1, $2) {
      return data[$2];
    });
  }
};
